import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export interface IMasterPassListItem {
  id: number;
  name: string;
  code: string;
  description: string;
}

export type GetMasterPassListForPageResponse = BasePagingResponse<
  Array<IMasterPassListItem>
>;

export type GetMasterPassListForPageRequest = {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
  status: string;
  [key: string]: string | number | boolean | undefined;
};

async function getMasterPassListForPage(
  data: GetMasterPassListForPageRequest
): Promise<GetMasterPassListForPageResponse> {
  try {
    return (await axiosInstance.post("/MasterPass/ListDefinition", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMasterPassListForPage() {
  return useMutation<
    GetMasterPassListForPageResponse,
    Error,
    GetMasterPassListForPageRequest
  >((variables) => getMasterPassListForPage(variables));
}
